module.exports = __webpack_public_path__ + "static/grung_green_blip-22efbabfda641effdb6281e38c118032.jpg";